import KeplerSdk from './../../keplerSdk.js'

const state = {
    drivers: [],
    driversLastFetch: null,
}

const mutations = {
    SET_DRIVERS_LIST (state, message) {
        state.drivers = message
    },
    SET_DRIVERS_LAST_FETCH (state, message) {
        state.driversLastFetch = message
    },
}

const actions = {
    fetchDrivers: ({commit}, payload) => {
        if (state.driversLastFetch == null) {
            KeplerSdk.drivers(function (data) {
                commit('SET_DRIVERS_LAST_FETCH', Math.floor(Date.now() / 1000))
                commit('SET_DRIVERS_LIST', data)
            }, function(error) {

            })
        }
    },
}

export default {
    state, mutations, actions
}


// WEBPACK FOOTER //
// ./src/store/frontoffice/driversStore.js